module.exports = __webpack_public_path__ + "static/q5_o-185b433d71cc044f67f337d685b851e3.png";